import Vue from "vue";
import Notifications from "vue-notification";
import velocity from "velocity-animate";
import App from "./App";
import router from "./router";
import store from "./store/store";
import VueCookies from "vue-cookies";
import vmodal from "vue-js-modal";
import globalMixin from "./mixin";
import VueGoodTablePlugin from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';

Vue.use(vmodal, { dialog: true });
Vue.use(VueCookies);
Vue.use(Notifications, { velocity });
Vue.use(VueGoodTablePlugin);
Vue.mixin(globalMixin);

Vue.config.productionTip = false;

Vue.filter("capitalize", function (value) {
  if (!value) return "";
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
